import { createContext, useContext } from 'react';

// Types
import { User } from '../../../../types';
import { View } from './types';

export interface DataSettingsModalContextType {
  user: User | null;
  // Methods
  onSetHeaderTitle: (title: string) => void;
  onSetHeaderSubtitle: (subtitle: string) => void;
  onClose: () => void;
  onUpdateUser?: (updatedUser: Partial<User>) => void;
}

const DefaultDataSettingsContext: DataSettingsModalContextType = {
  user: null,
  onSetHeaderTitle: () => {},
  onSetHeaderSubtitle: () => {},
  onClose: () => { },
  onUpdateUser: () => {},
};

export const DataSettingsContext = createContext<DataSettingsModalContextType>(DefaultDataSettingsContext);

export const useDataSettingsContext = () => {
  const context = useContext(DataSettingsContext);

  if (!context) {
    throw new Error('useDataSettingsModal must be used within a DataSettingsModalProvider');
  }

  return context;
}
